import { regionUrl } from '@helpers/vivinoUrls';
import t from 'vivino-js/translationString';
import { countryUrl } from 'vivino-js/vivinoUrls';
import { Region } from 'vivino-ui/icons/WineFacts';

const TRANSLATION_PATH = 'components.shared.wine_summary';
const TRANSLATIONS = {
  region: `${TRANSLATION_PATH}.region`,
  delimiter: `${TRANSLATION_PATH}.regions_delimiter`,
};

export const getRegionFact = (vintage, translationFunc = t) => {
  const region = vintage?.wine?.region;
  if (!region) {
    return null;
  }

  const values = [];

  const parentRegions = region.parent_regions;
  if (parentRegions) {
    const { country } = region;
    values.push({
      name: country.name,
      url: countryUrl({ country }),
    });
    const parentRegionValues = parentRegions.reverse().map((parentRegion) => ({
      name: parentRegion.name,
      url: regionUrl({ region: parentRegion }),
    }));
    values.push(...parentRegionValues);
  }

  values.push({
    name: region.name,
    url: regionUrl({ region }),
  });

  return {
    key: 'region',
    headerLabel: translationFunc(TRANSLATIONS.region),
    icon: Region,
    delimiter: translationFunc(TRANSLATIONS.delimiter),
    values,
  };
};
